import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import * as Constants from './../../helpers/constants'
import UserlistPage from '../user_list_page';
import ClearoutIndividualUserInfo from '../individual_user_info/clearout_individual_user_info';
import Coupons from '../coupons/coupons';
import ManageAbuse from '../abuse/manage_abuse';
import UpdateHistory from '../update_history/abuse_update_history';
import AbuseLogs from '../abuse_view_logs/abuse_view_logs';
import UserActivities from '../user_activities/user_activities';
import ServiceLists from '../service_list';
import ProductList from './../products/component/list'
import CreateProduct from './../products/component/create'
import GeneratePurchaseURL from './../products/component/generate_url'
import MiscellaneousApi from '../miscellaneous';
import PlanInfo from '../product_info/plan_info_card'
import CopAnnouncementBar from '../cop_announcement_bar'


const CLIENT = Constants.CLIENTS.EU_CLEAROUTPHONE.NAME

const euClearoutphoneRouter = createBrowserRouter([
  {
    id: 'dashboard-eu-clearoutphone-route',
    path: CLIENT,
    children: [
      {
        id: 'dashboard-eu-clearoutphone-users',
        path: 'users',
        element: <UserlistPage />
      },
      {
        id: 'dashboard-eu-clearoutphone-list',
        path: 'lists',
        element: <ServiceLists service={Constants.SERVICE_TYPES.PHONE_NUMBER_VERIFIER} />
      },
      {
        id: 'eu-clearoutphone-individual-user-info',
        path: 'individual_user_info',
        element: <ClearoutIndividualUserInfo />
      },
      {
        id: 'eu-copcoupons',
        path: 'coupons',
        element: <Coupons />
      },
      {
        id: 'eu-copcoupon',
        path: 'coupons/:couponId',
        element: <Coupons />
      },
      {
        id: 'dashboard-eu-clearoutphone-manage-abuse',
        path: 'abuse_list',
        element: <ManageAbuse />
      },
      {
        id: 'dashboard-eu-clearoutphone-view-logs',
        path: 'abuse_logs',
        element: <AbuseLogs />
      },
      {
        id: 'dashboard-eu-clearoutphone-update-logs',
        path: 'abuse_update_logs',
        element: <UpdateHistory />
      },
      {
        id: 'dashboard-eu-cop-user-activities',
        path: 'individual_user_activity',
        element: <UserActivities />
      },
      {
        id: 'eu-clearoutphone-plan-list',
        path: 'plan_list',
        element: <ProductList />
      },
      {
        id: 'eu-clearoutphone-create-plan',
        path: 'create_plan',
        element: <CreateProduct />
      },
      {
        id: 'eu-clearoutphone-generate-purchase-url',
        path: 'generate_purchase_url',
        element: <GeneratePurchaseURL />
      },
      {
        id: 'dashboard-eu-clearoutphone-miscellaneous-api',
        path: 'miscellaneous_api',
        element: <MiscellaneousApi />
      },
      {
        id: 'dashboard-eu-clearoutphone-announcement-bar',
        path: 'announcement_bar',
        element: <CopAnnouncementBar client={CLIENT} />
      },
      {
        id: 'eu-clearoutphone-plan-info',
        path: 'plan_info/:planId',
        element: <PlanInfo/>
      },
      {
        id: CLIENT + '-redirect',
        path: '*',
        element:
          <Navigate
            to={'users'}
            replace={true}
          />
      },
    ]
  }
])

export default euClearoutphoneRouter
